import { render, staticRenderFns } from "./interviewRecordDetail.vue?vue&type=template&id=da2529da&scoped=true"
import script from "./interviewRecordDetail.vue?vue&type=script&lang=js"
export * from "./interviewRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./interviewRecordDetail.vue?vue&type=style&index=0&id=da2529da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2529da",
  null
  
)

export default component.exports